// extracted by mini-css-extract-plugin
export var grid = "_i-0";
export var span1 = "_i-2";
export var span10 = "_i-b";
export var span10L = "_i-z";
export var span10M = "_i-n";
export var span10Xl = "_i-1b";
export var span11 = "_i-c";
export var span11L = "_i-10";
export var span11M = "_i-o";
export var span11Xl = "_i-1c";
export var span12 = "_i-d";
export var span12L = "_i-11";
export var span12M = "_i-p";
export var span12Xl = "_i-1d";
export var span1L = "_i-q";
export var span1M = "_i-e";
export var span1Xl = "_i-12";
export var span2 = "_i-3";
export var span2L = "_i-r";
export var span2M = "_i-f";
export var span2Xl = "_i-13";
export var span3 = "_i-4";
export var span3L = "_i-s";
export var span3M = "_i-g";
export var span3Xl = "_i-14";
export var span4 = "_i-5";
export var span4L = "_i-t";
export var span4M = "_i-h";
export var span4Xl = "_i-15";
export var span5 = "_i-6";
export var span5L = "_i-u";
export var span5M = "_i-i";
export var span5Xl = "_i-16";
export var span6 = "_i-7";
export var span6L = "_i-v";
export var span6M = "_i-j";
export var span6Xl = "_i-17";
export var span7 = "_i-8";
export var span7L = "_i-w";
export var span7M = "_i-k";
export var span7Xl = "_i-18";
export var span8 = "_i-9";
export var span8L = "_i-x";
export var span8M = "_i-l";
export var span8Xl = "_i-19";
export var span9 = "_i-a";
export var span9L = "_i-y";
export var span9M = "_i-m";
export var span9Xl = "_i-1a";
export var stretch = "_i-1";